import isValidAnswer from '@opsbase/lib-form/helpers/isValidAnswer';
import { SimpleTimeFormat } from '@opsbase/lib-time/consts';
import moment from 'moment-timezone';
import React, { useContext } from 'react';
import DetailsOpReportAnswerCell from './DetailsOpReportAnswerCell';
import { DetailsOpReportQuestionContext } from './DetailsOpReportQuestion';
export function DetailsOpReportAnswerDateTime() {
    const { r, a, q } = useContext(DetailsOpReportQuestionContext);
    const right = false;
    // If answered
    if (isValidAnswer(a, q, r)) {
        const c = r;
        const v = a.value;
        const m = moment(v).tz(moment.tz.guess());
        let fmt = 'MMM D YYYY';
        if (c.isDateRequired && c.isTimeRequired) {
            fmt = 'MMM D YYYY @ hh:mm A';
        }
        else if (c.isTimeRequired) {
            fmt = SimpleTimeFormat;
        }
        const text = m.format(fmt);
        return React.createElement(DetailsOpReportAnswerCell, { right: right }, text);
    }
    // Otherwise
    else {
        return React.createElement(DetailsOpReportAnswerCell, { right: right }, "- - -");
    }
}
export default DetailsOpReportAnswerDateTime;
